import React, { useState, useEffect, useRef, Fragment } from "react";
import "./listCustomersStyle.scss";
import {
  Table,
  Input,
  Space,
  Button,
  notification,
  DatePicker,
  Modal,
  List,
  Pagination,
  Popconfirm,
  Spin,
  Col,
  Row,
} from "antd";
import {
  PlusOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import ListCustomersService from "../../services/listCustomersService";
import moment from "moment";
import MessageService from "../../services/messageService";
import ModalUpload from "./ModalUpload";
import ModalMessage from "./ModalMessage";
import ModalEditUserInfo from "./ModalEditUserInfo";
import { ModalCrime } from "./ModalCrime";
import { VectorIcon } from "./../../assets/icons";
import { AnphaIcon } from "./../../assets/icons";

import { SubmittedIcon } from "./../../assets/icons";
import { Not_yetIcon } from "./../../assets/icons";
import { BUTTON_LOADING_TIME } from "constants/time";
import { widthLicensePlate } from "../../constants/licenseplates";
import { useSelector } from "react-redux";
import Handlebars from "handlebars";
import { routes } from "App";
import { useHistory } from "react-router-dom";
import { ERROR_FAILED } from "constants/errorConstant";
import UnLock from "components/UnLock/UnLock";
import TagVehicleWarn from "components/TagVehicle/TagVehicleWarn";
import BasicTablePaging from "components/BasicTablePaging/BasicTablePaging";
import { useModalDirectLinkContext } from "components/ModalDirectLink";

import ModalProgressCustomer from "components/EmailIcon/importCustomer";

import { MIN_COLUMN_WIDTH } from "constants/app";
import { EXTRA_BIG_COLUMND_WITDTH } from "constants/app";
import { BIGGER_COLUMN_WIDTH } from "constants/app";

import BasicButtonPrimary from "components/BasicButtonPrimary";
import FormCreateNewBooking from "Page/Accreditation/formCreateNewBooking";

const { RangePicker } = DatePicker;

const SMSListModal = ({ id, visible, onClose }) => {
  const { t: translation } = useTranslation();
  const [detail, setDetail] = useState({});
  const [pagable, setPagable] = useState({
    page: 1,
    skip: 0,
    limit: 5,
  });

  useEffect(() => {
    id &&
      MessageService.findMessages({
        filter: { customerId: id },
        skip: pagable.skip,
        limit: pagable.limit,
      }).then((result) => {
        if (result.data) {
          setDetail(result);
        }
      });
  }, [id, pagable.limit, pagable.skip]);

  return (
    <Modal
      title={translation("listCustomers.listSMSSent")}
      width={443}
      visible={visible}
      closable
      onCancel={onClose}
      footer={
        <div className="footers justify-content-end">
          <Button type="link" onClick={onClose}>
            {translation("listCustomers.cancel")}
          </Button>
          {/* <Button type="primary" onClick={onClose}>{translation("listSchedules.OK")}</Button> */}
          <BasicButtonPrimary
            onclick={onClose}
            text={translation("listSchedules.OK")}
          />
        </div>
      }
    >
      <div>
        {detail?.data?.length > 0 ? (
          <List>
            {detail?.data?.map((message) => (
              <List.Item className="d-block">
                <div className="d-flex justify-content-between">
                  <p className="text-one">
                    {translation("sms.messageSentDate")} :
                    <span className="text-day">
                      {message?.createdAt?.slice(11, 16)}{" "}
                      {moment(message?.createdAt?.slice(0, 10)).format(
                        "DD/MM/YYYY"
                      )}
                    </span>
                  </p>
                  <p
                    className="message-status"
                    data-status={message.messageSendStatus}
                  >
                    <SubmittedIcon />
                  </p>
                </div>
                <p className="text-two">
                  {translation("sms.content")} :<p>{message.messageContent}</p>
                </p>
              </List.Item>
            ))}
          </List>
        ) : (
          <div className="icons">
            <Not_yetIcon />
          </div>
        )}
        <div className="d-flex justify-content-between align-items-baseline mt-3">
          {/* <div>
						<p>Tong so SMS: {detail.total}</p>
					</div> */}
          {detail?.total > 20 ? (
            <Pagination
              total={detail.total}
              pageSize={pagable.limit}
              current={pagable.page}
              simple={true}
              onChange={(page) =>
                setPagable({
                  ...pagable,
                  page: page,
                  skip: (page - 1) * pagable.limit,
                })
              }
            />
          ) : (
            <></>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default function ListCustomer() {
  const { t: translation } = useTranslation();
  const setting = useSelector((state) => state.setting);
  const user = useSelector((state) => state.member);

  const history = useHistory();
  const [listDataCustomers, setListDataCustomer] = useState({
    data: [],
    total: 0,
  });
  const [percents, setPercents] = useState([]);
  const [isModalProgress, setisModalProgress] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [crimePlateNumber, setCrimePlateNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSendMessage, setIsSendMessage] = useState(false);
  const [isUploadFile, setIsUploadFile] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState({});
  const [upload, setUpload] = useState(false);
  const [message, setMessage] = useState({
    message: "",
    button: translation("listCustomers.selectAll", {
      total: listDataCustomers.total,
    }),
  });
  const [dataFilter, setDataFilter] = useState({
    filter: {},
    skip: 0,
    limit: 20,
    searchText: undefined,
    endDate: undefined,
    startDate: undefined,
    order: {
      key: "customerRecordId",
      value: "desc",
    },
  });
  const [fileSelected, setFileSelected] = useState(undefined);
  
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState([]);

  const [loadingUrl, setLoadingUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalSMSOpen, setIsModalSMSOpen] = useState(false);
  const [customerId, setCustomerId] = useState(null);
  const { setUrlForModalDirectLink } = useModalDirectLinkContext();
  const inputRef = useRef();
  const [isCreate, setIsCreate] = useState(false);

  const onExportListCustomers = () => {
    setLoadingUrl(true);
    ListCustomersService.exportListCustomers({
      ...dataFilter,
      skip: undefined,
      limit: undefined,
    }).then((url) => {
      setTimeout(() => {
        if (url) {
          setUrlForModalDirectLink(url);
        } else {
          notification["error"]({
            description: translation("listCustomers.exportFailed"),
          });
        }
        setLoadingUrl(false);
      }, 500);
    });
  };

  const columns = [
    {
      title: translation("landing.index"),
      dataIndex: "customerRecordId",
      key: "customerRecordId",
      width: MIN_COLUMN_WIDTH,
      render: (_, __, index) => {
        return (
          <div className="d-flex justify-content-center align-items-center">
            {dataFilter.skip ? dataFilter.skip + index + 1 : index + 1}
          </div>
        );
      },
    },
    {
      title: translation("listSchedules.fullName"),
      key: "customerRecordFullName",
      dataIndex: "customerRecordFullName",
      render: (_, record) => {
        return (
          <div>
            <div>{record.customerRecordFullName}</div>
            <div style={{ color: "#40E0D0", fontSize: "smaller" }}>
              {record?.companyName}
            </div>
          </div>
        );
      },
      width: EXTRA_BIG_COLUMND_WITDTH,
    },
    {
      title: translation("accreditation.phoneNumber"),
      dataIndex: "customerRecordPhone",
      key: "customerRecordPhone",
      width: BIGGER_COLUMN_WIDTH,
      render: (_, record) => {
        return (
          <div className="disflex">
            {record.customerRecordPhone && (
              <div
                className="blue-text"
                onClick={() => {
                  setIsModalSMSOpen(true);
                  setCustomerId(record.customerRecordId);
                }}
              >
                {record.customerRecordPhone}
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: translation("Email"),
      key: "customerRecordEmail",
      dataIndex: "customerRecordEmail",
      width: BIGGER_COLUMN_WIDTH,
      render: (_, record) => {
        return <div className="blue-text">{record.customerRecordEmail}</div>;
      },
    },
    {
      title: translation("accreditation.licensePlates"),
      dataIndex: "customerRecordPlatenumber",
      key: "customerRecordPlatenumber",
      width: widthLicensePlate,
      ellipsis: true,
      render: (_, item) => {
        const {
          customerRecordPlatenumber,
          crimesRecords
        } = item;
          return (
            <TagVehicleWarn
              crimesRecords={crimesRecords}
              onClick={() => {
                setCrimePlateNumber(customerRecordPlatenumber);
              }}
            >
              {customerRecordPlatenumber?.toUpperCase()}
            </TagVehicleWarn>
          );
      },
    },
    {
      title: translation("listCustomers.dateEnd"),
      key: "customerRecordCheckExpiredDate",
      dataIndex: "customerRecordCheckExpiredDate",
      width: BIGGER_COLUMN_WIDTH,
      render: (item) => {
        const itemSlice = item.length >= 10 ? `${item.slice(0, 10)}` : item;
        return <div>{itemSlice}</div>;
      },
    },
    {
      title: translation("listCustomers.customerRecordBHTNDSExpiredDate"),
      key: "customerRecordBHTNDSExpiredDate",
      dataIndex: "customerRecordBHTNDSExpiredDate",
      width: BIGGER_COLUMN_WIDTH,
      render: (item) => {
        const itemSlice = item ? item.length >= 10 ? `${item.slice(0, 10)}` : item : "";
        return <div>{itemSlice}</div>;
      },
    },
    {
      title: translation("listCustomers.act"),
      key: "action",
      // width: BIG_COLUMN_WIDTH,
      render: (_, record) => {
        return (
          <Space size="middle">
            <span
              onClick={() => {
                onOpenModal(record);
                if (inputRef && inputRef.current) {
                  setTimeout(() => {
                    inputRef.current.focus();
                  }, 0);
                }
              }}
              style={{ cursor: "pointer", color: "var(--primary-color)" }}
            >
              {translation("listCustomers.edit")}
            </span>
            <Popconfirm
              title={translation("listCustomers.confirm-delete")}
              onConfirm={() => {
                onDeleteCustomer(record && record.customerRecordId);
              }}
              okText={translation("category.yes")}
              cancelText={translation("category.no")}
            >
              <span
                style={{ cursor: "pointer", color: "var(--primary-color)" }}
              >
                {translation("listCustomers.delete")}
              </span>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  const toggleMessageModal = () => {
    setIsSendMessage((prev) => !prev);
  };

  const toggleUploadModal = () => {
    setIsUploadFile((prev) => !prev);
  };

  // rowSelection object indicates the need for row selection
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      if (selectedRowKeys.length > 0) {
        let arrCustomers = [];
        selectedRows.forEach((cus) => {
          let customer = {
            customerMessageEmail: cus.customerRecordEmail,
            customerMessagePhone: cus.customerRecordPhone,
            customerRecordPlatenumber: cus.customerRecordPlatenumber,
            customerId: cus.appUserId,
            customerRecordCheckExpiredDate: cus.customerRecordCheckExpiredDate,
          };
          arrCustomers.push(customer);
        });
        setSelectedCustomers(arrCustomers);
        setSelectedRowKeys(selectedRowKeys);
        if (selectedRowKeys.length === listDataCustomers.total) {
          setMessage({
            button: translation("listCustomers.undo"),
            message: `${listDataCustomers.total} ${translation(
              "listCustomers.selected"
            )}`,
          });
          return;
        }

        if (selectedRowKeys.length === listDataCustomers.data.length) {
          setMessage({
            button: translation("listCustomers.selectAll", {
              total: listDataCustomers.total,
            }),
            message: `${selectedRowKeys.length} ${translation(
              "listCustomers.selected"
            )}`,
          });
          return;
        }

        setMessage({
          button: translation("listCustomers.selectAll", {
            total: listDataCustomers.total,
          }),
          message: `${selectedRowKeys.length} ${translation(
            "listCustomers.selected"
          )}`,
        });
      } else {
        setMessage({
          button: translation("listCustomers.selectAll", {
            total: listDataCustomers.total,
          }),
          message: "",
        });
        setSelectedCustomers([]);
        setSelectedRowKeys([]);
      }
    },
    preserveSelectedRowKeys: true,
  };

  const fetchData = (filter) => {
    ListCustomersService.getData(filter).then((result) => {
      if (result) {
        setListDataCustomer(result);
      }
    });
  };

  useEffect(() => {
    isMobileDevice(window.outerWidth);
    fetchData(dataFilter);
  }, []);

  const onSearch = (value) => {
    dataFilter.searchText = value || undefined;
    dataFilter.skip = 0;
    setDataFilter({ ...dataFilter });
    fetchData(dataFilter);
  };

  const onFilterByDate = (date, dateString) => {
    if (date) {
      let start = dateString[0];
      let end = dateString[1];
      dataFilter.startDate = start;
      dataFilter.skip = 0;
      dataFilter.endDate = end;
      setDataFilter({ ...dataFilter });
      fetchData(dataFilter);
    } else {
      dataFilter.startDate = undefined;
      dataFilter.endDate = undefined;
      dataFilter.skip = 0;
      setDataFilter({ ...dataFilter });
      fetchData(dataFilter);
    }
  };

  const toggleEditModal = () => {
    setIsEditing((prev) => !prev);
  };

  const onOpenModal = (customer) => {
    toggleEditModal();
    setSelectedCustomer(customer);
  };

  const onUpdateCustomer = (values) => {
    values.customerRecordCheckDuration =
      values.customerRecordCheckDuration || 0;
    ListCustomersService.updateCustomerInfo({
      id: selectedCustomer.customerRecordId,
      ...values,
      customerRecordCheckDate:
        moment(values.customerRecordCheckDate).format("DD/MM/YYYY") || "",
      customerRecordCheckExpiredDate: values.customerRecordCheckExpiredDate
        ? moment(values.customerRecordCheckExpiredDate)
            .add(Number(values.customerRecordCheckDuration || 0), "months")
            .format("DD/MM/YYYY") || ""
        : "",
    }).then((result) => {
      const { statusCode, error } = result;
      if (statusCode === 200) {
        notification["success"]({
          message: "",
          description: translation("listCustomers.updateSuccess"),
        });
        toggleEditModal();
        fetchData(dataFilter);
        return true;
      }
      if (error === ERROR_FAILED.INVALID_PLATE_NUMBER) {
        notification["error"]({
          message: "",
          description: translation("error.INVALID_PLATE_NUMBER"),
        });
        return;
      }
      notification["error"]({
        message: "",
        description: translation("listCustomers.updateFailed"),
      });
      return false;
    });
  };

  const onDeleteCustomer = (id) => {
    ListCustomersService.deleteCustomerById(id).then((result) => {
      if (result && result.isSuccess) {
        notification["success"]({
          message: "",
          description: translation("listCustomers.deleteSuccess"),
        });
        fetchData(dataFilter);
      } else {
        notification["error"]({
          message: "",
          description: translation("listCustomers.deleteFailed"),
        });
      }
    });
  };

  const onUploadFile = () => {
    setFileSelected(true);
  };

  const onImportFileToDb = (arr) => {
    const newArr = arr.map((customer) => {
      return Object.entries(customer).reduce(
        (payload, [field, value]) => {
          const isEmpty =
            value === undefined ||
            value === null ||
            (typeof value === "string" && value.trim() === "");

          if (
            field !== "customerIndex" &&
            field !== "customerRecordAdress" &&
            !isEmpty
          ) {
            payload[field] = value;
          }

          return payload;
        },
        { customerStationId: user.stationsId }
      );
    });
    setPercents(newArr);
    setisModalProgress(true);
    setFileSelected(true);
    
  };

  function sendMessageByList(dataCustomerToSendMessage) {
    history.push(routes.sendSMS.path, {
      data: dataCustomerToSendMessage,
    });
  }

  const handleChangePage = (pageNum) => {
    const newFilter = {
      ...dataFilter,
      skip: (pageNum - 1) * dataFilter.limit,
    };
    setDataFilter(newFilter);
    fetchData(newFilter);
  };

  const onSendMessage = (values) => {
    if (selectedCustomers.length === 0) {
      notification.error({
        message: "",
        description: translation("listCustomers.noSelected"),
      });
      return false;
    } else {
      if (values) {
        //   // convert message
        let selectedCustomersApi = [...selectedCustomers];
        for (let i = 0; i < selectedCustomersApi.length; i++) {
          let dataObject = {
            stationsName: values.stationsName,
            stationCode: values.stationCode,
            stationsAddress: values.stationsAddress,
            stationsHotline: values.stationsHotline,
            customerRecordPlatenumber:
              selectedCustomersApi[i].customerRecordPlatenumber,
            vehiclePlateNumber:
              selectedCustomersApi[i].customerRecordPlatenumber,
            customerRecordCheckExpiredDate:
              selectedCustomersApi[i].customerRecordCheckExpiredDate,
            stationsHotline: values.stationsHotline,
          };
          selectedCustomersApi[i].customerMessageContent = Handlebars.compile(
            values.customerMessageContent
          )(dataObject);
        }
        let dataCustomerToSendMessage = {
          messageTemplateId: values.customerMessageTemplateId,
          template: values,
          customerList: selectedCustomersApi,
        };
        //send by list
        const status = sendMessageByList(dataCustomerToSendMessage);
        return status;
      }
    }
  };

  const onChangeSearchText = (e) => {
    setDataFilter({
      ...dataFilter,
      searchText: e.target.value.length > 0 ? e.target.value : undefined,
    });
  };

  const isMobileDevice = (value) => {
    if (value < 768) {
      dataFilter.limit = 10;
    }
  };

  return (
    <Fragment>
      {setting.enableCustomerMenu === 0 ? (
        <UnLock />
      ) : (
        <main className="list_customers">
          <Row gutter={[24, 24]} wrap align="start" justify="start" className="mb-3">
            <Col xl={4} lg={6} md={12} sm={12} xs={24}>
              <Input.Search
                autoFocus
                placeholder={translation("listCustomers.search")}
                onChange={onChangeSearchText}
                onSearch={onSearch}
              />
            </Col>
            <Col xl={4} lg={6} md={12} sm={12} xs={24}>
              <RangePicker
                className="w-100"
                format="DD/MM/YYYY"
                onChange={onFilterByDate}
                placeholder={[
                  translation("listCustomers.startDate"),
                  translation("listCustomers.endDate"),
                ]}
              />
            </Col>
            <Col xl={12} lg={24} md={24} sm={24} xs={24} className="d-flex gap-4 flex-wrap">
              <Button
                  onClick={toggleUploadModal}
                  className="d-flex align-items-center gap-2"
                  icon={<VectorIcon />}
              >
                  {translation("listCustomers.upload")}
                </Button>
                <Button
                  onClick={onExportListCustomers}
                  className="d-flex align-items-center gap-2"
                  icon={loadingUrl ? <Spin /> : <AnphaIcon />}
                >
                  {translation("listCustomers.export")}
                </Button>
                {!!setting.enableMarketingMessages && (
                  <BasicButtonPrimary
                    onclick={toggleMessageModal}
                    icon={<PlusOutlined />}
                    className="d-flex align-items-center gap-1"
                    text={translation("listCustomers.typeMessage")}
                  />
                )}
                <BasicButtonPrimary
                  onclick={() => {
                    setIsCreate(true);
                  }}
                  text={translation("inspectionProcess.add")}
                  icon={<PlusOutlined />}
                  className="d-flex align-items-center gap-1"
                />
                <Modal
                  visible={isCreate}
                  title={translation("landing.booking-title")}
                  onCancel={() => setIsCreate(!isCreate)}
                  footer={null}
                >
                  <FormCreateNewBooking reloadData={() => setIsCreate(false)} />
                </Modal>
                <Button
                  className="d-flex justify-content-center align-items-center"
                  type="default"
                  loading={loading}
                  disabled={loading}
                  icon={<ReloadOutlined />}
                  onClick={() => {
                    setLoading(true);
                    setTimeout(() => {
                      fetchData(dataFilter);
                      setLoading(false);
                    }, BUTTON_LOADING_TIME);
                  }}
                >
                </Button>
            </Col>
          </Row>
          {message.message && (
            <div className="d-flex justify-content-center pb-3">
              <div>
                <Button disabled type="text">
                  {message.message}
                </Button>
              </div>
            </div>
          )}
          <div className="list_customers">
            <Table
              rowKey="customerRecordId"
              dataSource={listDataCustomers.data}
              rowSelection={{
                ...rowSelection,
                selectedRowKeys: selectedRowKeys,
              }}
              columns={columns}
              scroll={{ x: 1312 }}
              pagination={false}
            />
            <BasicTablePaging
              handlePaginations={handleChangePage}
              skip={dataFilter.skip}
              count={listDataCustomers?.data?.length < dataFilter?.limit}
            ></BasicTablePaging>
          </div>
          <ModalEditUserInfo
            isEditing={isEditing}
            toggleEditModal={toggleEditModal}
            onUpdateCustomer={onUpdateCustomer}
            selectedCustomer={selectedCustomer}
            inputRef={inputRef}
          />
          <ModalMessage
            visible={isSendMessage}
            toggleMessageModal={toggleMessageModal}
            onSendMessage={onSendMessage}
            message={message.message}
          />
          <ModalUpload
            visible={isUploadFile}
            toggleUploadModal={toggleUploadModal}
            onUploadFile={onUploadFile}
            file={fileSelected}
            columns={columns}
            onImportFileToDb={onImportFileToDb}
            isLoading={isLoading}
            dataFilter={dataFilter}
            upload={upload}
            setUpload={setUpload}
            onClearUpload={() => setFileSelected(undefined)}
          />
          <SMSListModal
            id={customerId}
            visible={isModalSMSOpen}
            onClose={() => setIsModalSMSOpen(false)}
          />
          {!!crimePlateNumber && (
            <ModalCrime
              plateNumber={crimePlateNumber}
              onClose={() => setCrimePlateNumber("")}
            />
          )}
          {isModalProgress && (
            <ModalProgressCustomer
              visible={isModalProgress}
              setVisible={setisModalProgress}
              data={percents}
              setUpload={setUpload}
              toggleUploadModal={toggleUploadModal}
              setFileSelected={setFileSelected}
              fetchData={fetchData}
              dataFilter={dataFilter}
            />
          )}
        </main>
      )}
    </Fragment>
  );
}
